import * as yup from "yup";

import { t } from "@/i18n-js/instance";

export const canonicalUrlSchema = yup
  .string()
  .nullable()
  .trim()
  .max(255, () => t("meta_tag_attributes.canonical_url_too_long"))
  .test(
    "canonical-url",
    () => t("meta_tag_attributes.canonical_url_invalid"),
    value => {
      if (!value) return true;
      try {
        const url = new URL(value);
        return (
          // URL parsing accepts missing slashes and embedded newlines; require the literal HTTP(S) form.
          /^https?:\/\/\S+$/i.test(value) &&
          (url.protocol === "http:" || url.protocol === "https:") &&
          Boolean(url.hostname) &&
          // Match the server's rejection of incomplete or invalid percent escapes.
          !/%(?![0-9a-f]{2})/i.test(value) &&
          !value.includes("#")
        );
      } catch {
        return false;
      }
    },
  );

export const validateCanonicalUrl = (value: unknown) => {
  try {
    canonicalUrlSchema.validateSync(value);
    return true;
  } catch (error) {
    if (error instanceof yup.ValidationError) return error.message;
    throw error;
  }
};
